/*
 * The MIT License
 *
 * Copyright (c) 2015, Sebastian Sdorra
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

'use strict';

angular.module('sample.widgets.markdown', ['adf.provider', 'btford.markdown'])
  .config(function(dashboardProvider){
    dashboardProvider
      .widget('markdown', {
        title: 'Markdown',
        description: 'Markdown widget',
        controller: 'markdownCtrl',
        templateUrl: 'vendor/angular-dashboard-framework/widgets/markdown/markdown.html',
        edit: {
          templateUrl: 'vendor/angular-dashboard-framework/widgets/markdown/edit.html',
          reload: false
        }
      });
  }).controller('markdownCtrl', function($scope, config){
    if (!config.content){
      config.content = '';
    }
    $scope.config = config;
  });



// WEBPACK FOOTER //
// ./src/vendor/angular-dashboard-framework/widgets/markdown/markdown.js